// import _ from 'lodash';

/*****************************************************************
 * Wrap console.log to provide environmental level based logging
 */
export class ConsoleLog {
  constructor(logLevel) {
    this._levels = [ 'error', 'warn', 'info', 'http', 'verbose', 'debug', 'trace', 'none' ];
    this._isTesting = !!process.env.TESTING;
    const checkLevel = logLevel || process.env.LOG_LEVEL || 'warn';
    this.setLogLevel(checkLevel);
  }

  // static format(str, ...args) {
  //   console.log('%j',{str, args});
  //   const compiled = _.template(str);
  //   return compiled(args);
  // }

  /**
   * Set the logging level on this class
   * @params {string} level - level to set
   * @returns {*} the actual object set
   */
  setLogLevel(level) {
    let index = this._levels.findIndex((elem) => { return elem === level });
    if (index === -1) index = 1;
    this._logLevel = { lvl: this._levels[index], idx: index };
    return this._logLevel;
  }

  /**
   * error passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  error(...args) {
    if (this._logLevel.idx >= 0) {
      console.error(...args);
    }
  }
  /**
   * warn passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  warn(...args) {
    if (this._logLevel.idx >= 1) {
      console.warn(...args);
    }
  }
  /**
   * info passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  info(...args) {
    if (this._logLevel.idx >= 2) {
      console.info(...args);
    }
  }
  /**
   * http passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  http(...args) {
    if (this._logLevel.idx >= 3) {
      console.info(...args);
    }
  }
  /**
   * verbose passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  verbose(...args) {
    if (this._logLevel.idx >= 4) {
      console.info(...args);
    }
  }
  /**
   * debug passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  debug(...args) {
    if (this._logLevel.idx >= 5) {
      console.debug(...args);
    }
  }
  /**
   * trace passthru
   * @param {*} args - log arguments
   * @returns {*} - if testing .. the args, otherwise nothing
   */
  trace(...args) {
    if (this._logLevel.idx >= 6) {
      console.debug(...args);
    }
  }
}
